import React from 'react';
import Icon from './Icon';

const FactoryIcon = (props) => (
    <Icon {...props}>
        <path
            d="M2 21H22M3 21V12L8 8V12L13 8V12H16V5A1 1 0 0 1 17 4H20A1 1 0 0 1 21 5V21M6 16.5H9M11 16.5H14"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default FactoryIcon;
